<template>
  <v-app id="rozmer">
      <HelloWorld />
  </v-app>
</template>

<script>
import HelloWorld from "./components/HelloWorld.vue";

export default {
  name: "App",

  components: {
    HelloWorld
  },

  data: () => ({
    //
  })
};
</script>
<style lang="scss" scoped>
.v-application--wrap {
    min-height: 64px!important;
}
#rozmer {
    min-height: 64px!important;
}
</style>
